/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$('.close').click(function(){
  $('.PageOverlay').removeClass('custom_modal');
  $('#shipping').css('display', 'none');
  $('#sidebar-cart').attr('aria-hidden','false')
  $('body').removeClass('custom-body');
});


$(document).on("click",".Drawer__Close.Icon-Wrapper--clickable",function() {
  $('#sidebar-cart').attr('aria-hidden','true');
});

// modal js
function myFunctionpopup(item){
  var shipping = document.getElementById("shipping");
  shipping.style.display = "block";
  $('button.Drawer__Close.Icon-Wrapper--clickable').trigger('click');
  $('#sidebar-cart').attr('aria-hidden','true');
  setTimeout(function(){
    $('body').addClass('custom-body');
  },200);
}

function setProductActiveSlide(index) {
  var mainSlider = document.querySelector('#shopify-section-product-template .Product__Slideshow');
  var flktyInstance = Flickity.data(mainSlider);
  if (flktyInstance) {
    flktyInstance.select(index);
  }
}

function myFunction(item){

  if($(item).prop("checked") == true){
    $('.Curbside_term').removeAttr('disabled',false);
    $('button#Curbside').css("display", "block");
    $('button#Curbside_sample').css("display", "none");
  }
  else if($(item).prop("checked") == false){
    $('.Curbside_term').attr('disabled', true);
    $('button#Curbside').css("display", "none");
    $('button#Curbside_sample').css("display", "block");
  }
}
function myFunctioncheck(){
  alert("You must agree with the terms and conditions to checkout."); 
}


$(document).on("click",".custom-body",function() {
  setTimeout(function(){
    $('.shipping-box').css('display', 'none');
    $('body').removeClass('custom-body');

  },200);

});
$(document).ready(function(){
  $('.shipping-content').click(function( event ) {
    event.stopPropagation();
  }); 
  $('.previous_owner').click(function(){
    $('.sub_previous_owner').toggle();
  });
  $('.warrantyLink').click(function(){
    $('.form_main').toggle();
    $('.custom_btn').toggleClass('icon_plus_minus');
  });

  $('.ProductItem__ColorSwatchItem').click(function(){
    $(this).parents('.ProductItem__Info').find('.ProductItem__ColorSwatchItem').removeClass('active');
    $(this).parents('.add_selected_variant').addClass('active');
    $(this).addClass('active');
    $(this).parents('.add_selected_variant').find('.upsell_product_overlay').show();
  });
  $('.add_selected_variant .upsell_product_overlay').click(function(){
    $(this).parents('.add_selected_variant').find('.ProductItem__ColorSwatchItem').removeClass('active');
    $(this).parents('.add_selected_variant').removeClass('active');
    $(this).parents('.add_selected_variant').removeClass('styling_active');
    $(this).find('.upsell_product_overlay').hide();
  });

   $('.add_default_variant .plus_sign_first').click(function(){
   $(this).parents('.add_default_variant').addClass('active');
   $(this).parents('.add_selected_variant').find('.upsell_product_overlay').show();
   $(this).parents('.add_default_variant').addClass('styling_active'); 
   });
   $('.add_default_variant .plus_sign_second').click(function(){
   $(this).parents('.add_default_variant').addClass('active');
   $(this).parents('.add_default_variant').find('.upsell_product_overlay').show();
   $(this).parents('.add_default_variant').addClass('styling_active'); 
   });
   $('.add_default_variant .upsell_product_overlay').click(function(){
    $(this).parents('.add_default_variant').removeClass('styling_active');
    $(this).parents('.add_default_variant').removeClass('active'); 
   });
});
$(document).ready(function(){
  $('form .ProductForm__Variants input.ColorSwatch__Radio ').change(function(){
    setTimeout(function(){
      var checkbuttonstatus = $('.ProductForm__AddToCart').text();
      if(checkbuttonstatus == 'Sold Out'){
        $('button.custom-style-btn').text(checkbuttonstatus);
        $('button.custom-style-btn').prop("disabled",true);
      }else{
        $('button.custom-style-btn').text(checkbuttonstatus);
        $('button.custom-style-btn').prop("disabled",false);
      }
    },200);
  });

  
 $('.plus_sign_first').click(function(){
     $('.plus_sign_second').parents('.add_selected_variant').removeClass('styling_active');
     $('.plus_sign_second').parents('.add_selected_variant').removeClass('active');
     $('.plus_sign_second').parents('.add_selected_variant').find('.ProductItem__ColorSwatchItem').removeClass('active');
     $('.plus_sign_second').parents('.add_default_variant').removeClass('active');
     $('.plus_sign_second').parents('.add_default_variant').removeClass('styling_active');
    if($(this).parents('.add_selected_variant').hasClass('active') == true){  
   var pusell_arr = [];
     $('.add_selected_variant .ProductItem__ColorSwatchItem.active .ColorSwatch__Radio').each(function(){
      pusell_arr.push($(this).attr('id'));
    });
    $('.add_default_variant.active input.product_first_variant_id').each(function(){
      pusell_arr.push($(this).val());
    });
    console.log(pusell_arr);
    console.log(pusell_arr.length);
     $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data:{
        quantity: 1,
        id:pusell_arr
      },
        success: function(data) { 
        $.ajax({
          type: 'GET',
          url: '/cart',
          dataType: "html",
          success: function (data) {
            new updateDrawer();  
            $('.custom-style-btn').prop("disabled",false);
          }
        });
      }
    });
     } else if($(this).parents('.add_default_variant').hasClass('active') == true){
         var pusell_arr = [];
     $('.add_selected_variant .ProductItem__ColorSwatchItem.active .ColorSwatch__Radio').each(function(){
      pusell_arr.push($(this).attr('id'));
    });
    $('.add_default_variant.active input.product_first_variant_id').each(function(){
      pusell_arr.push($(this).val());
    });
    console.log(pusell_arr);
    console.log(pusell_arr.length);
     $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data:{
        quantity: 1,
        id:pusell_arr
      },
        success: function(data) { 
        $.ajax({
          type: 'GET',
          url: '/cart',
          dataType: "html",
          success: function (data) {
            new updateDrawer();  
            $('.custom-style-btn').prop("disabled",false);
          }
        });
      }
    });
     }
      
   });
  
   $('.plus_sign_second').click(function(){
     $('.plus_sign_first').parents('.add_default_variant').removeClass('active');
     $('.plus_sign_first').parents('.add_default_variant').removeClass('styling_active');
     $('.plus_sign_first').parents('.add_selected_variant').removeClass('styling_active');
     $('.plus_sign_first').parents('.add_selected_variant').removeClass('active');
     $('.plus_sign_first').parents('.add_selected_variant').find('.ProductItem__ColorSwatchItem').removeClass('active');
      if($(this).parents('.add_selected_variant').hasClass('active') == true){
     var pusell_arr = [];
     $('.add_selected_variant .ProductItem__ColorSwatchItem.active .ColorSwatch__Radio').each(function(){
      pusell_arr.push($(this).attr('id'));
    });
    $('.add_default_variant.active input.product_first_variant_id').each(function(){
      pusell_arr.push($(this).val());
    });
    console.log(pusell_arr);
    console.log(pusell_arr.length);
     $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data:{
        quantity: 1,
        id:pusell_arr
      },
        success: function(data) { 
        $.ajax({
          type: 'GET',
          url: '/cart',
          dataType: "html",
          success: function (data) {
            new updateDrawer();  
            $('.custom-style-btn').prop("disabled",false);
          }
        });
      }
    });
     } else if($(this).parents('.add_default_variant').hasClass('active') == true){
         var pusell_arr = [];
     $('.add_selected_variant .ProductItem__ColorSwatchItem.active .ColorSwatch__Radio').each(function(){
      pusell_arr.push($(this).attr('id'));
    });
    $('.add_default_variant.active input.product_first_variant_id').each(function(){
      pusell_arr.push($(this).val());
    });
    console.log(pusell_arr);
    console.log(pusell_arr.length);
     $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data:{
        quantity: 1,
        id:pusell_arr
      },
        success: function(data) { 
        $.ajax({
          type: 'GET',
          url: '/cart',
          dataType: "html",
          success: function (data) {
            new updateDrawer();  
            $('.custom-style-btn').prop("disabled",false);
          }
        });
      }
    });
     }
      
   });
   
 $('form .ProductForm__Variants input.ColorSwatch__Radio ').change(function(){
    setTimeout(function(){
      var checkbuttonstatus = $('.ProductForm__AddToCart').text();
      if(checkbuttonstatus == 'Sold Out'){
         $('.buylocation_available').hide();
         $('.buylocation_soldout').show();
      }else{
        $('.buylocation_soldout').hide();
		$('.buylocation_available').show();
        
      }
    },1000);
  });

});





function updateDrawer() {
  const rerenderCart = () => {
    let cartDot = [].slice.call(document.querySelectorAll('.Header__CartDot')),
        cartQuantity = [].slice.call(document.querySelectorAll('.Header__CartCount'));

    cartDot.forEach((item) => {
      if (this.itemCount === 0) {
        item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
      } else {
        item.classList.add('is-visible');
      }
    });

    cartQuantity.forEach((item) => {
      //item.textContent = this.itemCount;
      if ($("body").hasClass("custom_coll"))
      {
        item.textContent = this.itemCount;

      }
      else
      {
        jQuery.getJSON('/cart.js', function(cart) {
          var item=cart.item_count;
          $('body.template-product .Header__CartCount').html(item);
        }); 
      }
    });

    // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
    return fetch('/cart?view=' + (this.options['drawer'] ? 'drawer' : 'ajax') + '&timestamp=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET'
    }).then((content) => {
      content.text().then((html) => {
        replaceContent(html);
      });
    });
  }

  const replaceContent = (html) => {
    let tempElement = document.createElement('div');
    tempElement.innerHTML = html;

    // Convert in background
    // if (window.theme.currencyConversionEnabled) {
    //   __WEBPACK_IMPORTED_MODULE_2__helper_Currency__["default"].convertAll(tempElement);
    // }

    let cartNodeParent = this.element.querySelector('.Cart').parentNode;

    if (this.options['drawer']) {
      let currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop;
      cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
      this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;
    } else {
      // For dedicated page we replace the whole section if there is no more product
      if (this.itemCount === 0) {
        this.element.innerHTML = tempElement.querySelector('.shopify-section').firstElementChild.innerHTML;
      } else {
        cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
        this.element.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
      }
    }
  }

  this.element = document.getElementById('sidebar-cart');
  this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

  this.itemCount = parseInt(
    [].slice.call(document.querySelectorAll('.QuantitySelector__CurrentQuantity'))
    .map(x => parseInt(x.value))
    .reduce((a, b) => a + b, 0)
  ) + 1;

  this.drawer = new Drawer(this.element)

  rerenderCart().then(() => {
                      this.drawer.open()
  this.element.dataset.sectionSettings = JSON.stringify(this.options)
});
/*console.log('track');
snaptr('track', 'START_CHECKOUT');*/
}

const Drawer = function () {
  function Drawer(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Drawer);

    this.element = element;
    this.delegateElement = new domDelegate.Delegate(this.element);
    this.delegateBody = new domDelegate.Delegate(document.body);

    this.onOpen = options['onOpen'] || function () {};
    this.onClose = options['onClose'] || function () {};

    this.isOpen = false;
    this.direction = this.element.classList.contains('Drawer--fromLeft') ? 'fromLeft' : 'fromRight';

    this.pageOverlayElement = document.querySelector('.PageOverlay');

    this._attachListeners();
  }

  _createClass(Drawer, [{
    key: 'destroy',
    value: function destroy() {
      this.delegateBody.off('click', '[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]');
      this.delegateBody.off('click', '[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]');
      window.removeEventListener('resize', this._calculateMaxHeightListener);
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      this.isOpen ? this.close() : this.open();
    }
  }, {
    key: 'open',
    value: function open(event) {
      if (this.isOpen) {
        return;
      }

      if (event) {
        event.preventDefault();
      }

      this.element.setAttribute('aria-hidden', 'false');
      this._calculateMaxHeight();

      document.documentElement.classList.add('no-scroll');

      // This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
      // other browsers, this is the only way to achieve that
      disableBodyScroll(true, '[data-scrollable]');

      // We attach an event to the page overlay to close it
      this.pageOverlayElement.classList.add('is-visible');
      this.pageOverlayElement.addEventListener('click', this._closeListener);

      this.isOpen = true;

      this.onOpen(); // Call the callback to allow other code to hook their logic

      return false;
    }
  }, {
    key: 'close',
    value: function close(event) {
      if (!this.isOpen) {
        return;
      }

      if (event) {
        event.preventDefault();
      }

      this.element.setAttribute('aria-hidden', 'true');

      document.documentElement.classList.remove('no-scroll');

      disableBodyScroll(false, '[data-scrollable]');

      this.pageOverlayElement.classList.remove('is-visible');
      this.pageOverlayElement.removeEventListener('click', this._closeListener);

      this.isOpen = false;

      this.onClose(); // Call the callback to allow other code to hook their logic
    }
  }, {
    key: '_attachListeners',
    value: function _attachListeners() {
      this._openListener = this.open.bind(this);
      this._closeListener = this.close.bind(this);
      this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);

      this.delegateBody.on('click', '[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]', this._openListener);
      this.delegateBody.on('click', '[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]', this._closeListener);
      this.element.addEventListener('keyup', this._handleKeyboard.bind(this));
      window.addEventListener('resize', this._calculateMaxHeightListener);
    }

    /**
         * Make sure that we force a max-height so that the drawer always stays on screen
         */

  }, {
    key: '_calculateMaxHeight',
    value: function _calculateMaxHeight() {
      this.element.style.maxHeight = window.innerHeight + 'px';
    }
  }, {
    key: '_handleKeyboard',


    /**
         * Handle a11y events
         */
    value: function _handleKeyboard(event) {
      if (this.isOpen && event.keyCode === 27) {
        this.close();
      }
    }
  }]);

  return Drawer;
}();

//plus sign jquery for css
$('.plus_sign_first').click(function(){
if($(this).parents('.add_selected_variant').hasClass('active') != true){
$('.first_plus').addClass('plus');
setTimeout(function(){ 
$('.first_plus').removeClass('plus');
}, 500);
}else{
$(this).parents('.add_selected_variant.active').addClass('styling_active');
}
});

$('.plus_sign_second').click(function(){
if($(this).parents('.add_selected_variant').hasClass('active') != true){
$('.second_plus').addClass('plus');
setTimeout(function(){ 
$('.second_plus').removeClass('plus');
}, 500);
}else{
$(this).parents('.add_selected_variant.active').addClass('styling_active');
}
});
$('.ProductItem__ColorSwatchItem').click(function(){
$('.add_selected_variant.active').removeClass('styling_active');
$('.add_default_variant.active').removeClass('styling_active');
});


// product page show images according to variant select
if ($(window).width() > 1007) {
  $(document).ready(function(){
    $(".ColorSwatchList .HorizontalList__Item").on("click",function(){
      var color_selected=$(this).find('label').attr('data-tag').toLowerCase();
      $(".Product__SlideshowNavScroller span").each(function(){
        var data=$(this).attr('data-alt').toLowerCase();
        console.log("color"+color_selected);
        console.log(data);
        if(data.indexOf(color_selected) != -1 || data.indexOf("lifestyle") != -1 || data.indexOf("youtube") != -1 || data.indexOf("vimeo") != -1 )
        {
          $(this).show();
        }
        else{
          $(this).hide();
        }
      });
    });

    var color_selected=$(".ColorSwatchList .HorizontalList__Item").find('label').attr('data-tag').toLowerCase();
    $(".Product__SlideshowNavScroller span").each(function(){
      var data=$(this).attr('data-alt').toLowerCase();
        if(data.indexOf(color_selected) != -1 || data.indexOf("lifestyle") != -1 || data.indexOf("youtube") != -1 || data.indexOf("vimeo") != -1 )
      {
        $(this).show();
      }
      else{
        $(this).hide();
      }
    });
  });
}

jQuery(window).on("load", function(){
  setInterval(function(){
    jQuery("rev-count.product_tabs_data").show();
    if(jQuery(".Product__Info span.spr-badge-caption").text() == "No reviews"){
      jQuery(".product_tabs_data").text("(0)");
      jQuery(".product_tabs_data").attr("jt-rev-count", "0");
    }else{
      var revAppend = jQuery(".Product__Info span.spr-badge-caption").text();
      var revAppendA = revAppend.split(" rev");
      jQuery(".product_tabs_data").text("("+revAppendA[0]+")");
      jQuery(".product_tabs_data").attr("jt-rev-count", "("+revAppendA[0]+")");
    }
  }, 2000);
});

  $(document).ready(function(){
$(".input_plus_button_article input").keyup(function(event) {
    if (event.keyCode === 13) {
      var height= $("#section-header").height();
      var height1= height + 90;
          $('html, body').animate({
        scrollTop: $("#all_data_here").offset().top-height1
    }, 2000);

    }
});
    $("#myBtn").click(function(){
      var height= $("#section-header").height();
      var height1= height + 90;
          $('html, body').animate({
        scrollTop: $("#all_data_here").offset().top-height1
    }, 2000);
      
});
   
});

  $(document).ready(function(){
$('.blog_Article_slider_search input').keydown(function(){
var val =$(".blog_Article_slider_search input").val().toLowerCase();
$(".custom_class_h").each(function(){
var value = $(this).find(".ArticleItem__Content").text().toLowerCase();
var n = value.includes(val);
  console.log(n);
if(n){
$(this).show();
    $(".sorry_message").hide();
}
else{
$(this).hide();
  $(".sorry_message").show();
}

});
});
    
    $('.blog_Article_slider_search input').keyup(function(){
var val =$(".blog_Article_slider_search input").val().toLowerCase();
$(".custom_class_h").each(function(){
var value = $(this).find(".ArticleItem__Content").text().toLowerCase();
var n = value.includes(val);
if(n){
$(this).show();
    $(".sorry_message").hide();
}
else{
$(this).hide();
  }
        if($(".custom_class_h:visible").length < 1){
        console.log($(".custom_class_h:visible").length);
                $(".sorry_message").show();
      }
});
});
    
});


$(document).ready(function(){
  $('.similar_select').change(function() {
    var val1 =$("#Resource_Topic").val();
    var val3 =$("#owner").val();
    $(".custom_class_h").each(function(){
      var value = $(this).find(".values_hai").text();
      var n = value.includes(val1);
      var n2 = value.includes(val3);

      if(n && n2 ){
        $(this).show();
        $(".sorry_message").hide();
      }
      else{
        $(this).hide();
      }
        if($(".custom_class_h:visible").length < 1){
        console.log($(".custom_class_h:visible").length);
                $(".sorry_message").show();
      }
      
    });
  });
  
  ////////// slider 
  
  $(".ColorSwatchList-custom").click(function(){
var current = $(this).find("span").text();
setTimeout(function(){
  var i= 0;
  $(".Product__SlideshowNavImage").each(function(){
    var attr =$(this).attr("data-alt");
      
if(current == attr){
  console.log(i)
  setProductActiveSlide(i)
      console.log(current+'=='+attr+'=='+i);
      $(this).trigger("click");
  
      return false;
     }
  i++;
  });

}, 500);
});
});


$( "button.Collapsible__Button.Heading.u-h6.description" ).trigger( "click" );





$(".mobile-popup i").on('click', function() {
  $(".custom-model-main").addClass('model-open');
}); 
$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
});














// TAB
// $(document).on('click', '.tab-wrap ul li a', function (e) {
//     var curTabContentId = $(this).attr('href');
//     $(this).parents('.tab-wrap').find('ul li').removeClass('active');
//     $(this).parents('li').addClass('active');
//     $(this).parents('.tab-wrap').find('.tab-content-id').removeClass('active');
//     $(curTabContentId).addClass("active");
//     e.preventDefault();
// });



$(".sub-product-button2.Button-to-Buy-Local.shopify-payment-button__button--unbranded a.scroll-down-ancor-1").click(function() {
var height= $("header#section-header").height();
    $('html, body').animate({
        scrollTop: $(".main-class-product-compare-final-products").offset().top-height
    }, 2000);
});
